module.exports = __webpack_public_path__ + "static/media/logo_naranja.e391255a.svg";